import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.group.mail');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-group-mail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.group.mail/view.scss */
:host {
  display: block;
  --gm-bg: #fff;
  --gm-soft: #f1f5f9;
  --gm-title: #203750;
  --gm-text: #40536b;
  --gm-muted: #63748a;
  --gm-line: #dce5ee;
  --gm-accent: #175d9c;
  color: var(--gm-text);
}

:host-context(html.dark) {
  --gm-bg: #1e293b;
  --gm-soft: #263449;
  --gm-title: #e2e8f0;
  --gm-text: #cbd5e1;
  --gm-muted: #9cacc1;
  --gm-line: #3a4a60;
  --gm-accent: #8abcf0;
}

.group-mail {
  min-width: 0;
}

button:focus-visible, select:focus-visible, summary:focus-visible {
  outline: 3px solid #80b0e6;
  outline-offset: 3px;
}

.gm-note {
  color: var(--gm-muted);
  font-size: 13px;
  line-height: 1.7;
  margin: 0 0 14px;
}

.gm-filters {
  display: flex;
  gap: 12px;
  align-items: end;
  flex-wrap: wrap;
  background: var(--gm-bg);
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 14px;
}

.gm-filters label {
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 12px;
  color: var(--gm-muted);
  min-width: 220px;
}

.gm-filters select {
  height: 40px;
  border: 1px solid var(--gm-line);
  border-radius: 8px;
  padding: 8px 12px;
  background: var(--gm-bg);
  color: var(--gm-text);
  font-size: 13px;
}

.gm-button {
  border: 0;
  border-radius: 8px;
  background: var(--gm-soft);
  color: var(--gm-accent);
  padding: 10px 15px;
  white-space: nowrap;
  cursor: pointer;
  font-size: 13px;
}

.gm-button.primary {
  background: #175d9c;
  color: #fff;
}

.gm-button:disabled {
  opacity: 0.45;
  cursor: default;
}

.gm-list {
  min-width: 0;
  border-radius: 12px;
  background: var(--gm-bg);
  overflow: hidden;
}

.gm-scroll {
  overflow: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
  font-size: 13px;
}

th {
  text-align: left;
  background: var(--gm-soft);
  color: var(--gm-muted);
  font-size: 12px;
  font-weight: 500;
  padding: 14px 18px;
  white-space: nowrap;
}

td {
  padding: 18px;
  border-top: 1px solid var(--gm-line);
  vertical-align: top;
  min-width: 100px;
}

td strong {
  display: block;
  font-weight: 600;
  color: var(--gm-title);
  overflow-wrap: anywhere;
  margin-bottom: 5px;
}

td small {
  display: block;
  color: var(--gm-muted);
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.gm-subject {
  min-width: 230px;
  overflow-wrap: anywhere;
}

.gm-recipient {
  min-width: 170px;
  overflow-wrap: anywhere;
}

.gm-status {
  min-width: 180px;
  max-width: 280px;
}

.gm-time {
  min-width: 150px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.gm-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  padding: 4px 9px;
  background: var(--gm-soft);
}

.gm-badge.sent {
  background: #eaf6ef;
  color: #267047;
}

.gm-badge.uncertain, .gm-badge.missing_recipient, .gm-badge.retry {
  background: #fff4db;
  color: #855413;
}

.gm-badge.failed {
  background: #fdecef;
  color: #b53e48;
}

details {
  margin-top: 10px;
  font-size: 11px;
  color: var(--gm-muted);
}

summary {
  cursor: pointer;
  width: fit-content;
}

.gm-pagination {
  display: flex;
  gap: 9px;
  align-items: center;
  padding: 15px 18px;
  border-top: 1px solid var(--gm-line);
}

.gm-pagination span {
  margin-right: auto;
  font-size: 12px;
  color: var(--gm-muted);
}

.gm-empty {
  padding: 50px 20px;
  text-align: center;
  color: var(--gm-muted);
}

.gm-error, .gm-message {
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 13px;
  line-height: 1.6;
}

.gm-error {
  background: #fdecef;
  color: #ad3445;
}

.gm-message {
  background: #eaf6ef;
  color: #267047;
}

@media (max-width: 600px) {
  .gm-filters {
    padding: 14px;
  }
  .gm-filters label {
    min-width: 100%;
  }
  .gm-pagination {
    flex-wrap: wrap;
  }
}`],
})
export class ComponentGroupMailComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service) {}
    public status = '';
    public rows: any[] = [];
    public total = 0;
    public page = 1;
    public lastpage = 1;
    public loading = false;
    public retrying = '';
    public error = '';
    public message = '';
    private sequence = 0;
    private destroyed = false;
    public statuses: any = {
        pending: '발송 대기', retry: '자동 재발송 대기', processing: '발송 중', prepared: '업무 처리 확인 대기',
        sent: 'SMTP 접수 완료', failed: '발송 실패',
        uncertain: '전달 결과 확인 필요', missing_recipient: '수신자 확인 필요',
        canceled: '발송 취소', no_recipients: '발송 대상 없음'
    };
    public statusKeys = Object.keys(this.statuses);
    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }
    public ngOnDestroy() { this.destroyed = true; this.sequence++; }
    public async load(page = 1) {
        const seq = ++this.sequence;
        this.loading = true; this.error = '';
        await this.service.render();
        try {
            const response = await wiz.call('list_jobs', {status: this.status, page});
            if (seq !== this.sequence || this.destroyed) return;
            if (response.code !== 200) throw new Error(this.responseMessage(response.data, '메일 이력을 조회하지 못했습니다.'));
            this.rows = response.data.rows || [];
            this.total = response.data.total;
            this.page = response.data.page;
            this.lastpage = response.data.lastpage;
        } catch (error: any) {
            if (seq !== this.sequence || this.destroyed) return;
            this.error = error?.message || '메일 이력을 조회하지 못했습니다.';
            this.rows = []; this.total = 0;
        } finally {
            if (seq === this.sequence && !this.destroyed) {
                this.loading = false;
                await this.service.render();
            }
        }
    }
    private responseMessage(data: any, fallback: string) {
        return typeof data === 'string' ? data : data?.message || fallback;
    }
    public canRetry(row: any) { return row.can_retry !== false && ['failed', 'uncertain'].includes(row.status); }
    public async retry(row: any) {
        if (this.retrying || this.loading || !this.canRetry(row)) return;
        const uncertain = row.status === 'uncertain';
        if (uncertain && !window.confirm('이 메일은 SMTP 서버에 이미 전달되었을 수 있습니다. 다시 발송하면 수신자가 같은 메일을 중복으로 받을 수 있습니다. 발송 이력을 확인한 뒤 재발송을 요청하시겠습니까?')) return;
        this.retrying = String(row.id); this.error = ''; this.message = '';
        await this.service.render();
        try {
            const response = await wiz.call('retry', {job_id: row.id, confirm_uncertain: uncertain ? 'Y' : 'N'});
            if (this.destroyed) return;
            if (response.code !== 200) throw new Error(this.responseMessage(response.data, '재발송을 요청하지 못했습니다.'));
            this.message = this.responseMessage(response.data, '안내 메일 재발송을 요청했습니다.');
            await this.load(this.page);
        } catch (error: any) {
            if (!this.destroyed) this.error = error?.message || '재발송을 요청하지 못했습니다.';
        } finally {
            this.retrying = '';
            if (!this.destroyed) await this.service.render();
        }
    }
    public time(value: number | string) {
        const seconds = Number(value);
        if (!Number.isFinite(seconds) || seconds <= 0) return '—';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).format(new Date(seconds * 1000));
    }
    public contextName(row: any) {
        if (row.kind === 'community_leader_changed') return row.community_name || row.community_id || '커뮤니티 안내';
        return row.group_name || row.community_name || '그룹 안내';
    }
    public guidance(row: any) {
        if (row.kind === 'group_created' && row.status === 'missing_recipient') return '생성된 그룹의 PI 이메일을 확인해주세요.';
        if (row.kind === 'community_leader_changed' && row.status === 'missing_recipient') return '지정·해제된 커뮤니티 대표의 이메일을 확인해주세요.';
        if (row.status === 'missing_recipient') return '수신 가능한 PI·서비스 담당자 또는 대상 사용자 이메일을 확인해주세요.';
        if (row.status === 'uncertain') return '전달 여부를 먼저 확인해주세요. 재발송하면 중복 수신할 수 있습니다.';
        if (row.status === 'failed') return '실패 원인을 해결한 후 이 수신자의 메일만 재발송할 수 있습니다.';
        if (row.status === 'prepared') return '업무 처리의 완료 여부를 확인하고 있습니다. 완료 안내는 아직 발송하지 않았습니다.';
        if (row.status === 'no_recipients') return '알림을 받을 구성원이 없습니다.';
        return '';
    }
}

export default ComponentGroupMailComponent;